export function getFlattenedOptions(filter) {
  return filter.options.length > 0 ? filter.options : filter.optionGroups.flatMap(group => group.options);
}
export function findOptionText(options, value) {
  var _options$find;
  return (_options$find = options.find(o => o.value === value)) === null || _options$find === void 0 ? void 0 : _options$find.text;
}